/**
 * WordPress dependencies
 */
import { createBlock } from '@wordpress/blocks';
const transforms = {
  to: [{
    type: 'block',
    blocks: ['core/site-logo'],
    transform: _ref => {
      let {
        isLink,
        linkTarget
      } = _ref;
      return createBlock('core/site-logo', {
        isLink,
        linkTarget
      });
    }
  }]
};
export default transforms;
//# sourceMappingURL=transforms.js.map